<script>
	import bg from '$lib/images/bg.jpeg';	
	export let hasAppNavigation = false; 
	export let theme = '';
</script>
 

<div id="scroller" class={`h-svh antialiased font-open-sans flex flex-col overflow-auto ${theme === 'light' ? 'bg-white' : 'bg-transparent'} ${hasAppNavigation ? 'pb-20 xl:pb-0' : ''}`}>
	<!-- Background Image -->
	<div class="fixed inset-0 -z-10">
		<img class="bg-cover size-full" src={bg} alt="background" />
		<div class="absolute size-full inset-0 bg-black/40"></div>
	</div>
	<!-- Main Content -->
	<main class="flex-1 w-full flex flex-col relative text-white">
		<slot />
	</main>
</div>